// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Hotkeys-module__hotkey___efV6Z{color:var(--grayscale-secondary)}", "",{"version":3,"sources":["webpack://./src/pages/robot/Hotkeys/Hotkeys.module.scss"],"names":[],"mappings":"AAAA,gCACE,gCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hotkey": "Hotkeys-module__hotkey___efV6Z"
};
export default ___CSS_LOADER_EXPORT___;
